export default {
  flows: {
    start: {
      steps: [
        {
          title: 'Aloitetaan kysely! Miten voimme auttaa?',
          description: 'Valitse seuraavista vaihtoehdoista, jotta voimme jatkaa tilaustasi. Tämä auttaa meitä ymmärtämään tarpeesi ja tarjoamaan sopivan ratkaisun.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'radioGroup',
            name: 'Valinta1',
            options: [{
              value: 'Rikkinäinen laite',
              title: 'Laitteen huolto tai uusinta',
              description: 'Laitteesi on hajonnut, ja tarvitset joko nykyisen laitteen huoltoa tai kokonaan uuden laitteen'
            }, {
              value: 'Uusi pesulalaite',
              title: 'Uuden pesulalaitteen tilaus',
              description: 'Haluatko tilata uuden pesulakoneen? Valitse tämä vaihtoehto, jos tarvitset uuden laitteen uuteen pesulaan tai lisälaitteen nykyisen rinnalle.'
            }, {
              value: 'Avoin tarjouspyyntö',
              title: 'Avoin tarjouspyyntö',
              description: 'Haluat jättää tarjouspyynnön sähköisesti. Voit lisätä liitteitä ja kuvata tarpeesi tarkemmin, jotta asiantuntijamme voi tarjota sinulle parhaan mahdollisen ratkaisun'
            }, {
              value: 'Kartoituskäynti',
              title: 'Kartoituskäynti',
              description: 'Haluatko, että Hakosen asiantuntija tulee paikan päälle arvioimaan pesulakoneiden tarpeesi ja asennusolosuhteet? Valitse tämä maksuton kartoituskäynti, jos haluat tarkemman arvion paikan päällä.'
            }]
          }],
          onNext({ state, appContext, navigate, setPage }) {
            switch (state.Valinta1) {
              case 'Rikkinäinen laite':
                setPage(1)
                break
              case 'Uusi pesulalaite':
                setPage(2)
                break
              case 'Avoin tarjouspyyntö':
                appContext.setTypeOfRequest('Tarjouspyyntö')
                navigate('tarjouspyyntö')
                break
              case 'Kartoituskäynti':
                appContext.setTypeOfRequest('Kartoituskäynti')
                navigate('kartoituskäynti')
                break
            }
          }
        },
        {
          title: 'Miten haluat edetä?',
          description: 'Valitse seuraavista vaihtoehdoista, jotta voimme jatkaa tilaustasi. Tämä auttaa meitä ymmärtämään tarpeesi ja tarjoamaan sopivan ratkaisun.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'radioGroup',
            name: 'Valinta2',
            options: [{
              value: 'Huoltotilaus',
              title: 'Huoltotilaus',
              description: 'Hakonen selvittää, kannattaako vanha laite huoltaa vai onko uuden laitteen tilaus tarpeen. Asiantuntijamme arvioi tilanteen paikan päällä'
            }, {
              value: 'Vanhan laitteen korvaus vastaavalla laitteella',
              title: 'Vanhan laitteen korvaus vastaavalla laitteella',
              description: 'Tarvitsetko uuden pesulakoneen vanhan laitteen tilalle? Valitse tämä vaihtoehto, jos haluat korvata vanhan laitteen uudella vastaavin ominaisuuksin.'
            }]
          }],
          onBack({ setPage }) {
            setPage(0)
          },
          onNext({ state, appContext, navigate, setPage }) {
            switch (state.Valinta2) {
              case 'Huoltotilaus':
                appContext.setTypeOfRequest('Huoltotilaus')
                navigate('huoltotilaus')
                break
              case 'Vanhan laitteen korvaus vastaavalla laitteella':
                appContext.setTypeOfRequest('Vanhan laitteen korvaaminen')
                navigate('vanhalaite')
                break
            }
          }
        },
        {
          title: 'Miten haluat edetä?',
          description: 'Valitse seuraavista vaihtoehdoista, jotta voimme jatkaa tilaustasi. Tämä auttaa meitä ymmärtämään tarpeesi ja tarjoamaan sopivan ratkaisun.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'radioGroup',
            name: 'Valinta3',
            options: [{
              value: 'Annan itse lisätietoja',
              title: 'Annan itse lisätietoja tässä vaiheessa',
              description: 'Olen valmis antamaan tarkempia tietoja pesulakoneiden tarpeesta ja asennuksesta. Tämä auttaa meitä varmistamaan, että tilaus etenee sujuvasti ja kaikki yksityiskohdat tulevat huomioiduksi jo tässä vaiheessa.'
            }, {
              value: 'Kaipaan apua',
              title: 'Kaipaan apua',
              description: 'Tarvitsen asiantuntijan apua lisätietojen antamisessa tai päätöksenteossa. Haluan, että Hakosen asiakaspalvelu ottaa minuun yhteyttä ja ohjaa minut eteenpäin oikean ratkaisun löytämisessä.'
            }]
          }],
          onBack({ setPage }) {
            setPage(0)
          },
          onNext({ state, appContext, navigate, setPage }) {
            switch (state.Valinta3) {
              case 'Annan itse lisätietoja':
                appContext.setTypeOfRequest('Uusi laite')
                navigate('uusilaite')
                break
              case 'Kaipaan apua':
                setPage(3)
                break
            }
          }
        },
        {
          title: 'Miten haluat edetä?',
          description: 'Valitse seuraavista vaihtoehdoista, jotta voimme jatkaa tilaustasi. Tämä auttaa meitä ymmärtämään tarpeesi ja tarjoamaan sopivan ratkaisun.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'radioGroup',
            name: 'Valinta4',
            options: [{
              value: 'Avoin Tarjouspyyntö',
              title: 'Avoin Tarjouspyyntö',
              description: 'Haluat jättää tarjouspyynnön sähköisesti. Voit lisätä liitteitä ja kuvata tarpeesi tarkemmin, jotta asiantuntijamme voi tarjota sinulle parhaan mahdollisen ratkaisun'
            }, {
              value: 'Kartoituskäynti',
              title: 'Kartoituskäynti',
              description: 'Haluatko, että Hakosen asiantuntija tulee paikan päälle arvioimaan pesulakoneiden tarpeesi ja asennusolosuhteet? Valitse tämä maksuton kartoituskäynti, jos haluat tarkemman arvion paikan päällä.'
            }]
          }],
          onBack({ setPage }) {
            setPage(2)
          },
          onNext({ state, appContext, navigate, setPage }) {
            switch (state.Valinta4) {
              case 'Avoin Tarjouspyyntö':
                appContext.setTypeOfRequest('Tarjouspyyntö')
                navigate('tarjouspyyntö')
                break
              case 'Kartoituskäynti':
                appContext.setTypeOfRequest('Kartoituskäynti')
                navigate('kartoituskäynti')
                break
            }
          }
        }
      ]
    },
    huoltotilaus: {
      confirm: {
        title: 'Tilauksen lähetys',
        description: 'Varmista, että kaikki antamasi tiedot ovat oikein ennen tilauksen lähettämistä. Saat sähköpostiisi vahvistuksen, kun tilaus on vastaanotettu.',
        summaryLabel: 'Yhteenveto tilauksestasi',
        instruction: 'Kun olet tarkistanut tietosi, paina "Lähetä tilaus", niin aloitamme tilauksen käsittelyn.',
        buttonLabel: 'Lähetä tilaus'
      },
      thankYou: {
        title: 'Kiitos tilauksestasi!',
        descriptionHtml: '<p>Olemme vastaanottaneet tietosi, ja tilauksesi on nyt käsittelyssä. Saat pian sähköpostitse vahvistuksen sekä lisätietoja seuraavista vaiheista.</p><p><strong>Mitä seuraavaksi?</strong><br/> Asiantuntijamme käy läpi lähettämäsi tiedot ja on sinuun yhteydessä mahdollisimman pian. Jos sinulla on kysyttävää tilaukseesi liittyen, voit aina olla yhteydessä asiakaspalveluumme.</p>'
      },
      steps: [
        {
          title: 'Huoltotarpeen kuvaus',
          description: 'Täytä alla olevat kentät, jotta voimme käsitellä tilauksesi. Tämä auttaa meitä varmistamaan, että saat tarvitsemasi laitteet mahdollisimman nopeasti ja tarkasti.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: false,
            type: 'text',
            name: 'Merkki ja malli',
            label: 'Huoltoa tarvitsevan laitteen merkki ja malli',
          }, {
            isRequired: true,
            type: 'textArea',
            name: 'Kuvaus viasta',
            label: 'Kuvaus viasta tai vikakoodi'
          }, {
            isRequired: false,
            type: 'file',
            name: 'Kuva tyyppikilvestä tai laitteesta',
            label: 'Kuva tyyppikilvestä tai laitteesta'
          }],
        },
        {
          title: 'Tilaajan Yhteystiedot',
          description: 'Täytä tilauksen vastuuhenkilön yhteystiedot.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'text',
            name: 'Etu- ja sukunimi',
            label: 'Etu- ja sukunimi'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Puhelinnumero',
            label: 'Puhelinnumero'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Sähköposti',
            label: 'Sähköposti'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Laskutettavan yrityksen nimi',
            label: 'Laskutettavan yrityksen nimi',
            tooltip: 'Syötä yrityksen virallinen nimi, jota käytetään laskutuksessa.'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Laskutettavan yrityksen Y-tunnus',
            label: 'Laskutettavan yrityksen Y-tunnus',
            tooltip: 'Anna yrityksen Y-tunnus muodossa 1234567-8. Tämä tieto tarvitaan laskutusta varten.'
          }, {
            isRequired: true,
            type: 'checkbox',
            name: 'Valtuus edustaa tilaajaorganisaatiota',
            label: 'Minulla on valtuudet edustaa tilaajaorganisaatiota'
          }],
        }, {
          title: 'Kohteen tiedot',
          description: null,
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'text',
            name: 'Kohteen osoite',
            label: 'Kohteen osoite'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Kohteen postinumero',
            label: 'Kohteen postinumero'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Kuinka pääsemme sisään?',
            label: 'Kuinka pääsemme sisään?',
            tooltip: 'Oven avausta varten tarvittavat yhteystiedot, kuten yhteyshenkilön nimi, ovikoodi tai avaimen noutotiedot'
          }, {
            isRequired: false,
            type: 'textArea',
            name: 'Muita lisätietoja, kuten pesutuvan tarkka sijainti',
            label: 'Muita lisätietoja, kuten pesutuvan tarkka sijainti',
            tooltip: 'Voit lisätä tähän kenttään muita tärkeitä tietoja, kuten pesutuvan tarkan sijainnin, rapputiedot tai muita lisätietoja'
          }],
        }
      ]
    },
    vanhalaite: {
      confirm: {
        title: 'Tilauksen lähetys',
        description: 'Varmista, että kaikki antamasi tiedot ovat oikein ennen tilauksen lähettämistä. Saat sähköpostiisi vahvistuksen, kun tilaus on vastaanotettu.',
        summaryLabel: 'Yhteenveto tilauksestasi',
        instruction: 'Kun olet tarkistanut tietosi, paina "Lähetä tilaus", niin aloitamme tilauksen käsittelyn.',
        buttonLabel: 'Lähetä tilaus'
      },
      thankYou: {
        title: 'Kiitos tilauksestasi!',
        descriptionHtml: '<p>Olemme vastaanottaneet tietosi, ja tilauksesi on nyt käsittelyssä. Saat pian sähköpostitse vahvistuksen sekä lisätietoja seuraavista vaiheista.</p><p><strong>Mitä seuraavaksi?</strong><br/> Asiantuntijamme käy läpi lähettämäsi tiedot ja on sinuun yhteydessä mahdollisimman pian. Jos sinulla on kysyttävää tilaukseesi liittyen, voit aina olla yhteydessä asiakaspalveluumme.</p>'
      },
      steps: [
        {
          title: 'Vanhan laitteen tiedot',
          description: 'Täytä alla olevat kentät, jotta voimme käsitellä tilauksesi. Tämä auttaa meitä varmistamaan, että saat tarvitsemasi laitteet mahdollisimman nopeasti ja tarkasti.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: false,
            type: 'text',
            name: 'Merkki ja malli',
            label: 'Vanhan laitteen merkki ja malli',
          }, {
            isRequired: false,
            type: 'file',
            name: 'Kuva laitteesta ja asennustilasta',
            label: 'Kuva laitteesta ja asennustilasta'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Laitteen tunniste',
            label: 'Viallisen laitteen sarjanumero tai muu tunniste jos samoja laitteita on useampi'
          }, {
            isRequired: true,
            type: 'radioGroup',
            name: 'Vanhan laitteen kierrätys',
            label: 'Kierrätetäänkö vanha laite?',
            tooltip: 'Kierrätämme vanhan laitteesi ilmaiseksi uuden laitteen asennuksen yhteydessä',
            options: [{
              value: 'Kyllä',
              title: 'Kyllä'
            }, {
              value: 'Ei',
              title: 'Ei'
            }]
          }],
        },
        {
          title: 'Kulku asennuskohteelle',
          description: 'Asentajallamme tulee olla esteetön pääsy asennuskohteelle.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: false,
            type: 'radioGroup',
            name: 'Onko kulkureitti pesulaan esteetön?',
            label: 'Onko kulkureitti pesulaan esteetön?',
            options: [{
              value: 'Kyllä',
              title: 'Kyllä'
            }, {
              value: 'Ei',
              title: 'Ei'
            },
            {
              value: 'En osaa sanoa',
              title: 'En osaa sanoa'
            }]
          }, {
            isRequired: false,
            type: 'textArea',
            name: 'Kuvaile kulkureittillä olevat mahdolliset esteet, kapeikot tai portaikot',
            label: 'Kuvaile kulkureittillä olevat mahdolliset esteet, kapeikot tai portaikot',
            tooltip: 'Ovatko kulkureitit riittävän avoimet vanhan laitteen poistamiseksi ja uuden tuomiseksi? Ilmoita kapeimman kulkuväylän leveys. Onko kohteessa rappusia tai hissi?'
          }, {
            isRequired: false,
            type: 'radioGroup',
            name: 'Vanhan laitteen purkaminen',
            label: 'Edellyttääkö vanhan laitteen poisto kiinteiden rakenteiden purkamista?',
            options: [{
              value: 'Kyllä',
              title: 'Kyllä'
            }, {
              value: 'Ei',
              title: 'Ei'
            }]
          }],
        },
        {
          title: 'Tilaajan Yhteystiedot',
          description: null,
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'text',
            name: 'Etu- ja sukunimi',
            label: 'Etu- ja sukunimi'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Puhelinnumero',
            label: 'Puhelinnumero'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Sähköposti',
            label: 'Sähköposti'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Yrityksen nimi',
            label: 'Yrityksen nimi'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Y-tunnus',
            label: 'Y-tunnus'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Laskutettavan yrityksen nimi',
            label: 'Laskutettavan yrityksen nimi'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Laskutettavan yrityksen Y-tunnus',
            label: 'Laskutettavan yrityksen Y-tunnus'
          }
          ],
        }, {
          title: 'Kohteen tiedot',
          description: null,
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'text',
            name: 'Kohteen osoite',
            label: 'Kohteen osoite'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Kohteen postinumero',
            label: 'Kohteen postinumero'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Ovikoodi tai avaimen noutotiedot',
            label: 'Ovikoodi tai avaimen noutotiedot'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Pesutuvan sijainti',
            label: 'Pesutuvan tarkka sijainti jos kohteessa on useita rappuja',
            tooltip: 'Syötä tähän tiedot joilla huoltoasentaja pääsee kohteeseen'
          }],
        }
      ]
    },
    uusilaite: {
      confirm: {
        title: 'Tilauksen lähetys',
        description: 'Varmista, että kaikki antamasi tiedot ovat oikein ennen tilauksen lähettämistä. Saat sähköpostiisi vahvistuksen, kun tilaus on vastaanotettu.',
        summaryLabel: 'Yhteenveto tilauksestasi',
        instruction: 'Kun olet tarkistanut tietosi, paina "Lähetä tilaus", niin aloitamme tilauksen käsittelyn.',
        buttonLabel: 'Lähetä tilaus'
      },
      thankYou: {
        title: 'Kiitos tilauksestasi!',
        descriptionHtml: '<p>Olemme vastaanottaneet tietosi, ja tilauksesi on nyt käsittelyssä. Saat pian sähköpostitse vahvistuksen sekä lisätietoja seuraavista vaiheista.</p><p><strong>Mitä seuraavaksi?</strong><br/> Asiantuntijamme käy läpi lähettämäsi tiedot ja on sinuun yhteydessä mahdollisimman pian. Jos sinulla on kysyttävää tilaukseesi liittyen, voit aina olla yhteydessä asiakaspalveluumme.</p>'
      },
      steps: [
        {
          title: 'Ennen kuin aloitetaan',
          description: 'Hakonen asentaa laitteet valmiiseen asennuspaikkaan, joten varmistathan, että tarvittavat tekniset valmiudet (sähkö, vesi, viemäri, ilmanvaihto) ovat kunnossa. Tarvittaessa voimme tilata sähköurakoinnin puolestasi yhteistyökumppanin kautta. Jos kaipaat apua asennuspaikan teknisten vaatimusten arvioinnissa, tarjoamme maksuttoman kartoituskäynnin, jossa asiantuntijamme selvittää paikan päällä asennusolosuhteet ja mahdolliset urakointitarpeet.',
          disclaimer: 'Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
        },
        {
          title: 'Tarpeiden kuvaus',
          description: 'Täytä alla olevat kentät, jotta voimme käsitellä tilauksesi. Tämä auttaa meitä varmistamaan, että saat tarvitsemasi laitteet mahdollisimman nopeasti ja tarkasti.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'textArea',
            name: 'Tarpeet uusille pesulalaitteille',
            label: 'Kuvaile tarpeesi uusien pesulalaitteiden osalta',
            tooltip: 'Kuvaile laitteen käyttötarkoitus. Onko laite tarkoitettu vaatteiden pesuun tai kuivaukseen, siivousvälineiden pesuun tai kuivaukseen, vai hoitolaitoskäyttöön?'
          }, {
            isRequired: false,
            type: 'file',
            name: 'Kuvat sijoituspaikasta',
            label: 'Liitä kuvia, piirustuksia tai muuta tarpeellista tietoa laitteen sijoituspaikasta',
            tooltip: 'Liitä kuva asennustilasta. Voit myös lisätä piirustuksia tai muuta tarpeellista tietoa (kuva tai PDF), jotta voimme varmistaa laitteen sopivuuden ja asennuksen sujuvuuden.',
            multiple: true
          }, {
            isRequired: true,
            type: 'laitevalinta',
            name: 'Laitevalinta',
            label: 'Valitse tarvitsemasi laitteet',
            options: [
              { value: 'Pesukone', label: 'Pesukone' },
              { value: 'Kuivausrumpu', label: 'Kuivausrumpu' },
              { value: 'Kuivaushuoneen kuivauskone', label: 'Kuivaushuoneen kuivauskone' },
              { value: 'Kuivauskaappi', label: 'Kuivauskaappi' },
            ]
          }],
        },
        {
          title: 'Sähköntarve',
          description: null,
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          conditions: [{
            name: 'Laitevalinta',
            containsOneOf: [
              {'Tyyppi': 'Pesukone'},
              {'Tyyppi': 'Kuivausrumpu'},
              {'Tyyppi': 'Kuivaushuoneen kuivauskone'},
              {'Tyyppi': 'Kuivauskaappi'}
            ]
          }],
          inputs: [{
            isRequired: false,
            type: 'radioGroup',
            name: 'Sähkövirran tyyppi',
            label: 'Sähkövirran tyyppi',
            options: [{
              value: 'Yksivaihevirta',
              title: 'Yksivaihevirta (valovirta)'
            }, {
              value: 'Kolmivaihevirta',
              title: 'Kolmivaihevirta (voimavirta)'
            }]
          }, {
            isRequired: false,
            type: 'radioGroup',
            name: 'Sähkövirran kytkeminen',
            label: 'Sähkövirran kytkeminen',
            tooltip: 'Onko sähkövirran kytkentä turvakytkimen vai pistorasian kautta? Huomioithan, että rikkinäinen turvakytkin voidaan vaihtaa uuteen, mutta uuden turvakytkimen asentamisesta vastaa tilaaja',
            options: [{
              value: 'Turvakytkin',
              title: 'Turvakytkin'
            }, {
              value: 'Pistorasia',
              title: 'Pistorasia'
            }]
          }, {
            isRequired: true,
            type: 'text',
            name: 'Johdotuksen sallima maksimi sulakekoko',
            label: 'Johdotuksen sallima maksimi sulakekoko',
            tooltip: 'Johdotus määrittää käytettävän sulakkeen koon, ja yleisimmät sulakekoot ovat 16A ja 25A. Jos johdotus sallii 25A sulakkeen, voimme asentaa suuremman ja tehokkaamman laitteen ilman, että sähköjärjestelmä kuormittuu liikaa.'
          }],
        },
        {
          title: 'Vesi ja viemäröinti',
          description: null,
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          conditions: [{
            name: 'Laitevalinta',
            containsOneOf: [
              {'Tyyppi': 'Pesukone'},
              {'Tyyppi': 'Kuivausrumpu'},
              {'Tyyppi': 'Kuivaushuoneen kuivauskone'},
              {'Tyyppi': 'Kuivauskaappi'}
            ]
          }],
          inputs: [{
            isRequired: true,
            type: 'textArea',
            name: 'Minkälainen viemäröinti / poistovesiputket on tilassa?',
            label: 'Minkälainen viemäröinti / poistovesiputket on tilassa?',
            tooltip: 'Kuinka paljon viemäri vetää vettä? Anna lattiakaivon halkaisija (mm) tai poistovesiputken halkaisija (mm).'
          }, {
            isRequired: false,
            type: 'radioGroup',
            name: 'Saadaanko tilaan kylmä vai lämmin vesi?',
            label: 'Saadaanko tilaan kylmä vai lämmin vesi?',
            options: [{
              value: 'Kylmä',
              title: 'Kylmä'
            }, {
              value: 'Kylmä & Lämmin',
              title: 'Kylmä & Lämmin'
            }]
          }, {
            isRequired: true,
            type: 'text',
            name: 'Miten kaukana viemäri sijaitsee laitteesta?',
            label: 'Miten kaukana viemäri sijaitsee laitteesta?',
            tooltip: 'Yli metrin etäisyys aiheuttaa lisätöitä asennuksessa'
          }
          ],
        },
        {
          title: 'Ilmanvaihto',
          description: null,
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          conditions: [{
            name: 'Laitevalinta',
            containsOneOf: [
              {'Tyyppi': 'Kuivausrumpu'},
              {'Tyyppi': 'Kuivauskaappi'}
            ]
          }],
          inputs: [{
            isRequired: false,
            type: 'radioGroup',
            name: 'Onko tilassa koneellinen vai painovoimainen ilmanvaihto',
            label: 'Onko tilassa koneellinen vai painovoimainen ilmanvaihto',
            options: [{
              value: 'Koneellinen',
              title: 'Koneellinen'
            }, {
              value: 'Painovoimainen',
              title: 'Painovoimainen'
            }]
          }, {
            isRequired: false,
            type: 'radioGroup',
            name: 'Onko tilassa poistohormi jota laite voi käyttää',
            label: 'Onko tilassa poistohormi jota laite voi käyttää',
            options: [{
              value: 'Kyllä',
              title: 'Kyllä'
            }, {
              value: 'Ei',
              title: 'Ei'
            }]

          }, {
            isRequired: false,
            type: 'text',
            name: 'Anna poistohormin halkaisija',
            label: 'Anna poistohormin halkaisija (cm)',
            conditions: [{
              name: 'Onko tilassa poistohormi jota laite voi käyttää',
              equals: 'Kyllä'
            }]
          }, {
            isRequired: false,
            type: 'text',
            name: 'Tilan koko (m3)',
            label: 'Tilan koko (m3)',
            conditions: [{
              name: 'Onko tilassa poistohormi jota laite voi käyttää',
              equals: 'Ei'
            }]
          }, {
            isRequired: false,
            type: 'text',
            name: 'Onko tilassa lattiakaivoa tai muuta vedenpoistopistettä?',
            label: 'Onko tilassa lattiakaivoa tai muuta vedenpoistopistettä?',
            conditions: [{
              name: 'Onko tilassa poistohormi jota laite voi käyttää',
              equals: 'Ei'
            }]
          }
          ]
        }, {
          title: 'Tilan yleinen soveltuvuus',
          description: null,
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          conditions: [{
            name: 'Laitevalinta',
            containsOneOf: [
              {'Tyyppi': 'Pesukone'},
              {'Tyyppi': 'Kuivaushuoneen kuivauskone'},
            ]
          }],
          inputs: [{
            isRequired: false,
            type: 'radioGroup',
            name: 'Onko tila märkätila vai kuiva tila?',
            label: 'Onko tila märkätila vai kuiva tila?',
            options: [{
              value: 'Märkätila',
              title: 'Märkätila'
            }, {
              value: 'Kuiva tila',
              title: 'Kuiva tila'
            }]
          }, {
            isRequired: false,
            type: 'radioGroup',
            name: 'Asennetaanko laite kakulle vai jalustalle?',
            label: 'Asennetaanko laite kakulle vai jalustalle?',
            tooltip: 'Onko alusta kiinteä betonirakenne (kakku) vai tarvitaanko alle valmistajan metallijalusta?',
            options: [{
              value: 'Kakulle',
              title: 'Kakulle'
            }, {
              value: 'Jalustalle',
              title: 'Jalustalle'
            }]

          },
          ],
        },
        {
          title: 'Lisävarusteet ja oheislaitteet',
          description: null,
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: false,
            type: 'radioGroup',
            name: 'Onko pesutuvassa digitaalinen ajavarausjärjestelmä?',
            label: 'Onko pesutuvassa digitaalinen ajavarausjärjestelmä?',
            options: [{
              value: 'Kyllä',
              title: 'Kyllä'
            }, {
              value: 'Ei',
              title: 'Ei'
            }]
          }, {
            isRequired: false,
            type: 'radioGroup',
            name: 'Onko pesukoneessa automaattinen pesuaineen annostelija?',
            label: 'Onko pesukoneessa automaattinen pesuaineen annostelija?',
            options: [{
              value: 'Kyllä',
              title: 'Kyllä'
            }, {
              value: 'Ei',
              title: 'Ei'
            }]
          }, {
            isRequired: false,
            type: 'radioGroup',
            name: 'Tarvitseko pesulaasi lisävarusteita, kuten mankelia, pyykkinarua yms',
            label: 'Tarvitseko pesulaasi lisävarusteita, kuten mankelia, pyykkinarua yms',
            options: [{
              value: 'Kyllä',
              title: 'Kyllä'
            }, {
              value: 'Ei',
              title: 'Ei'
            }]
          }, {
            isRequired: false,
            type: 'textArea',
            name: 'Kuvaile tarvitsemiasi lisävarusteita',
            label: 'Kuvaile tarvitsemiasi lisävarusteita',
            conditions: [{
              name: 'Tarvitseko pesulaasi lisävarusteita, kuten mankelia, pyykkinarua yms',
              equals: 'Kyllä'
            }]
          }
          ],
        },
        {
          title: 'Tilaajan Yhteystiedot',
          description: null,
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'text',
            name: 'Etu- ja sukunimi',
            label: 'Etu- ja sukunimi'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Puhelinnumero',
            label: 'Puhelinnumero'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Sähköposti',
            label: 'Sähköposti'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Yrityksen nimi',
            label: 'Yrityksen nimi'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Y-tunnus',
            label: 'Y-tunnus'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Laskutettavan yrityksen nimi',
            label: 'Laskutettavan yrityksen nimi'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Laskutettavan yrityksen Y-tunnus',
            label: 'Laskutettavan yrityksen Y-tunnus'
          }
          ],
        },
        {
          title: 'Kohteen tiedot',
          description: null,
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'text',
            name: 'Kohteen osoite',
            label: 'Kohteen osoite'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Kohteen postinumero',
            label: 'Kohteen postinumero'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Ovikoodi tai avaimen noutotiedot',
            label: 'Ovikoodi tai avaimen noutotiedot'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Pesutuvan sijainti',
            label: 'Pesutuvan tarkka sijainti jos kohteessa on useita rappuja',
            tooltip: 'Syötä tähän tiedot joilla huoltoasentaja pääsee kohteeseen'
          }],
        }
      ]
    },
    kartoituskäynti: {
      confirm: {
        title: 'Kartoituskäynnin lähetys',
        description: 'Varmista, että kaikki antamasi tiedot ovat oikein ennen tilauksen lähettämistä. Saat sähköpostiisi vahvistuksen, kun tilaus on vastaanotettu.',
        summaryLabel: 'Yhteenveto kartoituskäynnistä',
        instruction: 'Kun olet tarkistanut tietosi, paina "Lähetä tilaus", niin aloitamme tilauksen käsittelyn.',
        buttonLabel: 'Lähetä pyyntö kartoituskäynnille'
      },
      thankYou: {
        title: 'Kiitos kartoituskäyntipyynnöstäsi!',
        descriptionHtml: '<p>Olemme vastaanottaneet tietosi, ja tilauksesi on nyt käsittelyssä. Saat pian sähköpostitse vahvistuksen sekä lisätietoja seuraavista vaiheista.</p><p><strong>Mitä seuraavaksi?</strong><br/> Asiantuntijamme käy läpi lähettämäsi tiedot ja on sinuun yhteydessä mahdollisimman pian. Jos sinulla on kysyttävää tilaukseesi liittyen, voit aina olla yhteydessä asiakaspalveluumme.</p>'
      },
      steps: [
        {
          title: 'Yhteystiedot',
          description: 'Maksuton kartoituskäynti paikan päällä auttaa arvioimaan pesulalaitteiden tarpeesi ja asennusolosuhteet tarkasti, jotta voimme tarjota sinulle parhaan mahdollisen ratkaisun ilman ylimääräisiä kustannuksia tai yllätyksiä.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'text',
            name: 'Etu- ja sukunimi',
            label: 'Etu- ja sukunimi',
          }, {
            isRequired: true,
            type: 'text',
            name: 'Sähköposti',
            label: 'Sähköposti',
          }, {
            isRequired: true,
            type: 'text',
            name: 'Puhelinnumero',
            label: 'Puhelinnumero',
          }, {
            isRequired: true,
            type: 'radioGroup',
            name: 'Ensisijainen yhteydenottotapa',
            label: 'Ensisijainen yhteydenottotapa',
            options: [{
              value: 'Puhelimitse',
              title: 'Puhelimitse'
            }, {
              value: 'Sähköpostilla',
              title: 'Sähköpostilla'
            }]
          }, {
            isRequired: false,
            type: 'textArea',
            name: 'Tarkempi kuvaus',
            label: 'Kuvaile tarvettasi'
          }, {
            isRequired: false,
            type: 'file',
            name: 'Liitetiedostot',
            label: 'Liitetiedostot (kuvat tai asiakirjat, jotka selkeyttävät tilannettasi)',
            multiple: true
          }],
        },
        {
          title: 'Kohteen tiedot',
          description: 'Täytä alla olevat kentät, jotta voimme käsitellä tilauksesi. Tämä auttaa meitä varmistamaan, että saat tarvitsemasi laitteet mahdollisimman nopeasti ja tarkasti.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: false,
            type: 'text',
            name: 'Yrityksen / Taloyhtiön nimi',
            label: 'Yrityksen / Taloyhtiön nimi'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Y-tunnus',
            label: 'Y-tunnus'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Kohteen osoite',
            label: 'Kohteen osoite'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Kohteen postinumero',
            label: 'Kohteen postinumero'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Kohteen paikkakunta',
            label: 'Kohteen paikkakunta'
          }],
        }
      ]
    },
    tarjouspyyntö: {
      confirm: {
        title: 'Avoimen tarjouspyynnön lähetys',
        description: 'Varmista, että kaikki antamasi tiedot ovat oikein ennen tarjouspyynnön lähettämistä. Saat sähköpostiisi vahvistuksen, kun tilaus on vastaanotettu.',
        summaryLabel: 'Yhteenveto tarjouspyynnöstäsi',
        instruction: 'Kun olet tarkistanut tietosi, paina "Lähetä tarjouspyyntö", niin aloitamme pyyntösi käsittelyn.',
        buttonLabel: 'Lähetä tarjouspyyntö'
      },
      thankYou: {
        title: 'Kiitos tarjouspyynnöstäsi!',
        descriptionHtml: '<p>Olemme vastaanottaneet tietosi, ja tarjouspyyntösi on nyt käsittelyssä. Saat pian sähköpostitse vahvistuksen sekä lisätietoja seuraavista vaiheista.</p><p><strong>Mitä seuraavaksi?</strong><br/> Asiantuntijamme käy läpi lähettämäsi tiedot ja on sinuun yhteydessä mahdollisimman pian. Jos sinulla on kysyttävää tilaukseesi liittyen, voit aina olla yhteydessä asiakaspalveluumme.</p>'
      },
      steps: [
        {
          title: 'Yhteystiedot',
          description: 'Voit lähettää tarjouspyynnön sähköisesti täyttämällä alla olevat tiedot. Liitä mukaan tarpeelliset liitteet ja kerro tarkemmin, millaista ratkaisua tarvitset, jotta asiantuntijamme voi valmistella sinulle juuri tarpeisiisi sopivan tarjouksen.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: true,
            type: 'text',
            name: 'Etu- ja sukunimi',
            label: 'Etu- ja sukunimi',
          }, {
            isRequired: true,
            type: 'text',
            name: 'Sähköposti',
            label: 'Sähköposti',
          }, {
            isRequired: true,
            type: 'text',
            name: 'Puhelinnumero',
            label: 'Puhelinnumero',
          }, {
            isRequired: true,
            type: 'radioGroup',
            name: 'Ensisijainen yhteydenottotapa',
            label: 'Ensisijainen yhteydenottotapa',
            options: [{
              value: 'Puhelimitse',
              title: 'Puhelimitse'
            }, {
              value: 'Sähköpostilla',
              title: 'Sähköpostilla'
            }]
          }, {
            isRequired: false,
            type: 'textArea',
            name: 'Tarkempi kuvaus',
            label: 'Tarkempi kuvaus mitä asiasi koskee'
          }, {
            isRequired: false,
            type: 'file',
            name: 'Liitetiedostot',
            label: 'Liitetiedostot (kuvat tai asiakirjat, jotka selkeyttävät tilannettasi)',
            multiple: true
          }],
        },
        {
          title: 'Kohteen tiedot',
          description: 'Täytä alla olevat kentät, jotta voimme käsitellä tilauksesi. Tämä auttaa meitä varmistamaan, että saat tarvitsemasi laitteet mahdollisimman nopeasti ja tarkasti.',
          disclaimer: 'Jos olet epävarma, valitse vaihtoehto, joka parhaiten kuvaa tilannettasi. Voit myös ottaa yhteyttä <a href="/asiakaspalvelu/" target="_blank">asiakaspalveluumme</a> saadaksesi apua valinnan tekemisessä.',
          inputs: [{
            isRequired: false,
            type: 'text',
            name: 'Yrityksen / Taloyhtiön nimi',
            label: 'Yrityksen / Taloyhtiön nimi'
          }, {
            isRequired: false,
            type: 'text',
            name: 'Y-tunnus',
            label: 'Y-tunnus'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Kohteen osoite',
            label: 'Kohteen osoite'
          }, {
            isRequired: true,
            type: 'text',
            name: 'Kohteen postinumero',
            label: 'Kohteen postinumero'
          }],
        }
      ]
    },
  }
}
